import { callProcedure } from 'core/classes/helpers/callProcedure'
import Logger from 'core/utils/Logger'

export const deleteAssortmentGroup = async (entryId: number) => {
  try {
    await callProcedure('spJBPAssortmentGroupDel', {
      'p.EntryId': entryId,
    })
    return true
  } catch (e) {
    Logger.log(e)
    return false
  }
}
